'use client';

import { useTranslations } from '@/app/providers';
import { useEffect, useRef, useState } from 'react';

const Values = () => {
  const t = useTranslations();
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Start revealing when section enters viewport, complete when it reaches top third
      const start = windowHeight;
      const end = windowHeight * 0.3;
      const current = rect.top;
      
      const progress = Math.min(1, Math.max(0, (start - current) / (start - end)));
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Split text into words for the reveal effect
  const words = t.values.text.split(' ');
  const totalWords = words.length;

  const getWordStyle = (wordIndex: number) => {
    const wordProgress = wordIndex / totalWords;
    const isRevealed = scrollProgress > wordProgress;
    
    return {
      color: isRevealed ? 'white' : 'rgba(255, 255, 255, 0.2)',
      transition: 'color 0.3s ease-out',
    };
  };

  return (
    <section ref={sectionRef} id='values' className='container mx-auto px-6 mt-16 md:mt-0 pb-28 md:pb-12'>
      <p className='max-w-210.5 border-l-8 border-brand-violet-500 pl-6 text-[2rem] md:text-[2.5rem] font-normal leading-[150%]'>
        {words.map((word, i) => (
          <span key={i} style={getWordStyle(i)}>
            {word}{' '}
          </span>
        ))}
      </p>
    </section>
  );
};

export default Values;


